import { render, staticRenderFns } from "./AdminTranslation.vue?vue&type=template&id=ec01e7a4&scoped=true&"
import script from "./AdminTranslation.ts?vue&type=script&lang=ts&"
export * from "./AdminTranslation.ts?vue&type=script&lang=ts&"
import style0 from "./AdminTranslation.scss?vue&type=style&index=0&id=ec01e7a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec01e7a4",
  null
  
)

export default component.exports